export default __webpack_public_path__ + "static/media/ea72a8e61db37e906108832c2d9e4b31.svg";